import { render, staticRenderFns } from "./CashiersDashboard.vue?vue&type=template&id=9fc08a18&scoped=true"
import script from "./CashiersDashboard.vue?vue&type=script&lang=js"
export * from "./CashiersDashboard.vue?vue&type=script&lang=js"
import style0 from "./CashiersDashboard.vue?vue&type=style&index=0&id=9fc08a18&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fc08a18",
  null
  
)

export default component.exports